import { z } from "zod";
const schemaExchangeType = z.enum(["SWAP", "SELL", "FUND"]);
const schemaExchangeStartParams = z.object({
    exchangeType: schemaExchangeType,
});
const schemaExchangeStartResults = z.object({
    transactionId: z.string(),
});
export const schemaExchangeStart = {
    params: schemaExchangeStartParams,
    result: schemaExchangeStartResults,
};
//# sourceMappingURL=ExchangeStart.js.map